export default "__VITE_ASSET__09wJNK0M__"